import apiService from "./api";
import { sanitizeQueryParams } from "@src/utility/helpers/apiHelper";
import type {
  AddAppNotification,
  IAppNotificationLogSearchOptions,
  IAppNotificationSearchOptions,
  TargetValueParams,
} from "@src/views/apps/platform-configuration/app-notifications/types";

export class AppNotificationService {
  async getAppNotifications(query?: IAppNotificationSearchOptions) {
    return apiService.get("/app-notifications", {
      params: sanitizeQueryParams(query || {}),
    });
  }

  async getAppNotificationDetails(id: string | number) {
    return apiService.get(`/app-notifications/${id}`);
  }

  async getTargetValues(params: TargetValueParams) {
    return apiService.get("/app-notifications/target-values", {
      params: sanitizeQueryParams({
        targetType: params.targetType,
        resource: params.resource,
        roleIds: Array.isArray(params.roleIds)
          ? params.roleIds.join(",")
          : params.roleIds,
      }),
    });
  }

  async addAppNotification(data: AddAppNotification) {
    return apiService.post("/app-notifications", data);
  }

  async updateAppNotification(
    id: string | number,
    data: Partial<AddAppNotification>
  ) {
    return apiService.put(`/app-notifications/${id}`, data);
  }

  async deleteAppNotification(id: string | number) {
    return apiService.delete(`/app-notifications/${id}`);
  }

  async sendAppNotification(id: string | number) {
    return apiService.post(`/app-notifications/${id}/send`);
  }

  async getAppNotificationLogs(query?: IAppNotificationLogSearchOptions) {
    return apiService.get("/app-notifications/logs", {
      params: sanitizeQueryParams(query || {}),
    });
  }

  async getAppNotificationLogDetails(logId: string | number) {
    return apiService.get(`/app-notifications/logs/${logId}`);
  }

  async getLogsForAppNotification(
    notificationId: string | number,
    query?: Omit<IAppNotificationLogSearchOptions, "notificationId">
  ) {
    return apiService.get(`/app-notifications/${notificationId}/logs`, {
      params: sanitizeQueryParams(query || {}),
    });
  }
}

export const appNotificationService = new AppNotificationService();
